<template>
	<div class="chat-panel-history">
		<ul class="chat-panel-history__tabs">
			<li v-for="(item,index) in tabs" :key="index" :class="{'active': active_tab == index}" @click="onSwitch(index)">
				{{item}}</li>
		</ul>
		<div class="chat-panel-history__boxes">
			<history-list 
			:customerId="customerId" 
			:apiUrl="apiUrl[active_tab]" 
			:responseType="responseType[active_tab]" 
			:senderType="senderType[active_tab]"
			:active="active_tab"></history-list>
			<el-button type="primary" class="return-btn" @click="$emit('onClose')">返回聊天</el-button>
		</div>
	</div>
</template>

<script>
	import { mapState} from 'vuex'
	export default {
		computed: {
		  ...mapState({
				customerId:state => state.imChatService.index_infos.customerId,
			}),
		},
		data(){
			return {
				tabs: ["机器人聊天历史", "坐席聊天历史"],
				active_tab: 1,
				apiUrl:['/livechat/msg/list/ai','/livechat/msg/list'],//机器人聊天  im历史聊天 
				responseType:['data','list'],
				senderType:['senderType','sender_type']
				
			}
		},
		methods:{
			onSwitch(index) {
				 this.active_tab = index; 
			},
		}
	}
</script>

<style lang="scss" scoped>
	.chat-panel-history {
		width: 100%;
		height: 100%;
		background: #fff;
		position: absolute;
		top: 0;
		left: 0;
		color: #838a9d;
		font-size: 12px;
		z-index: 998;
		&__tabs {
			display: flex;
		
			li {
				list-style: none;
				width: 50%;
				height: 32px;
				background: #f6f7f9;
				border: 1px solid #d8d8d8;
				line-height: 32px;
				text-align: center;
				border-top: none;
				cursor: pointer;
		
				&.active {
					color: #337eff;
					background: none;
					border: none;
				}
			}
		}
		&__boxes {
			width: 100%;
			height: calc(100% - 32px);
			position: relative;
			::v-deep {
				.el-button {
					position: absolute;
					bottom: 20px;
					width: 160px;
					height: 34px;
					left: calc((100% - 160px) / 2);
					font-size: 14px;
				}
			}
		}
	}
</style>
